import React from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'antd';
import { Building03Icon, Home02Icon, MessageMultiple01Icon, TaskDaily01Icon, WalletDone02Icon } from 'hugeicons-react';

interface FinanceSidebarProps {
  isMobile?: boolean;
  onNavigate?: () => void;
}

const FinanceSidebar: React.FC<FinanceSidebarProps> = ({ isMobile = false, onNavigate }) => {
  const handleClick = () => {
    onNavigate?.();
  };

  const financeMenu = [
    { key: 'dashboard', label: 'Genel Görünüm', to: '/', icon: Home02Icon, tooltip: 'Genel Görünüm', exact: true },
    { key: 'companies', label: 'Firmalar', to: '/companies', icon: Building03Icon, tooltip: 'Firmalar' },
    { key: 'reminders', label: 'Görevler', to: '/reminders', icon: TaskDaily01Icon, tooltip: 'Görevler' },
    { key: 'payments', label: 'Ödemeler', to: '/payments', icon: WalletDone02Icon, tooltip: 'Ödemeler' },
    { key: 'support', label: 'Destek', to: '/tickets', icon: MessageMultiple01Icon, tooltip: 'Destek' },
  ];

  return (
    <>
      <div className={`menu-item-container ${isMobile ? 'mobile-menu' : ''}`}>
        {financeMenu.map(({ key, label, to, icon: Icon, tooltip, exact }) => (
          <NavLink
           key={key}
            to={to}
            end={exact}
            className="menu-link"
            onClick={handleClick}
          >
            {({ isActive }) => (
              <div className="menu-item-wrapper">
                <div className={`menu-item ${isActive ? 'active' : ''}`}>
                  {!isMobile ? (
                    <Tooltip title={tooltip || label} placement="right">
                      <Icon style={{ fontSize: '24px', color: isActive ? 'white' : 'gray' }} />
                    </Tooltip>
                  ) : (
                    <Icon style={{ fontSize: '24px', color: isActive ? 'white' : 'gray' }} />
                  )}
                </div>
                {isMobile && <span className="menu-title">{label}</span>}
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </>
  );
};

export default FinanceSidebar;
